import { Store } from '../Store';
import {
    addLinkParamsInStore,
    addAllRefPCPClinAndActonPopUpOpenInStore,
    addAllRefPCPAndACtionPlanDetailsInStore,
    updateSelectedLanguageInStore,
    updateUserRoleInStore,
    insertPagePermission,
    clearPagePermission,
    resetCommonStore
} from './reducer';

export const addLinkParamsToStore = (data) => Store.dispatch(addLinkParamsInStore(data));

export const addAllRefPCPClinAndActonPopUpOpenToStore = (val) => Store.dispatch(addAllRefPCPClinAndActonPopUpOpenInStore(val));

export const addAllRefPCPAndACtionPlanDetailsToStore = (val) => Store.dispatch(addAllRefPCPAndACtionPlanDetailsInStore(val));

export const updateSelectedLanguageToStore = (val) => Store.dispatch(updateSelectedLanguageInStore(val));

export const updateUserRoleToStore = (val) => Store.dispatch(updateUserRoleInStore(val));

export const insertPagePermissionToStore = (val) => Store.dispatch(insertPagePermission(val));

export const clearPagePermissionToStore = () => Store.dispatch(clearPagePermission());

export const resetCommonStoreToStore = () => Store.dispatch(resetCommonStore());
